import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService, AppService, LocalStorageService } from '../../../service';
import { Router } from '@angular/router';
import { now } from 'moment';
import { ModalController, NavParams, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi
import { debounceTime } from 'rxjs/operators';

@Component({
	selector: 'app-reject-page-select',
	templateUrl: './reject-page-select.component.html',
	styleUrls: ['./reject-page-select.component.scss'],
})
export class RejectPageSelectComponent implements OnInit {
	pageTitle = '';
	searchMessage = '';
	placeholderMessage = '';
	originalOptionList = [];
	optionList = [];
	displayField: any;
	valueField = '';
	multiSelect = false;
	needFilterSearch = false;
	selected: any;
	format = '';
	cancelText = '';
	confirmText = '';
	isStaff = false;
	isOrg = false;
	instantClose = false;
	staffNumber = 50;
	staffSearchQuery = [];
	currentPage = 1;
	preventRepeatRequest: boolean = false;
	staffTotal = 0;
	isNotifier = false;
	lastSearchTime = new Date().getTime();
	needShowColor = false;

	isLoading = false;
	bbsoStatus = '';
	constructor(
		public dataService: DataService,
		public appService: AppService,
		public router: Router,
		public navCtrl: NavController,
		public navParams: NavParams,
		public modalController: ModalController,
		public localStorageService: LocalStorageService,
		private translateService: TranslateService) {
		let params = this.navParams.data;
		this.pageTitle = params.pageTitle ? params.pageTitle : '';
		this.placeholderMessage = params.placeholderMessage ? params.placeholderMessage : '';
		this.originalOptionList = params.optionList ? params.optionList : [];
		this.cancelText = params.cancelText ? params.cancelText : 'common.cancel';
		this.confirmText = params.confirmText ? params.confirmText : 'common.confirm';
		this.selected = params.selected ? params.selected : null;
	}

	ngOnInit() {
		// Ionic modal 的 componentProps 是在构造函数之后通过 Object.assign 直接赋值到实例属性上的，
		// 此时才是 pageTitle 的最终原始值（翻译 key），因此翻译必须放在这里而不是构造函数里。
		this.pageTitle = this.translateService.instant(this.pageTitle);
		// 设置标题
		document.getElementsByTagName('title').item(0).innerText = this.pageTitle;
		if (dd.env.platform !== 'notInDingTalk') {
			dd.biz.navigation.setTitle({
				title: this.pageTitle // 钉钉设置导航栏标题
			});
		}
		this.optionList = this.originalOptionList;

		const that = this;
		window.onpopstate = function () {
			const a = document.getElementsByTagName('app-new-page-select');
			if (a.length > 0) {
				setTimeout(() => {
					that.modalController.dismiss();
					// history.back();
				}, 100)
			}
		};
	}

	markSelected(item) {
		this.selected = item;
		this.confirm();
	}

	isSelected(item) {
		if (this.selected) {
			if (item.employee.id === this.selected.employee.id && 
				item.org.id === this.selected.org.id &&
				item.responsibility === this.selected.responsibility) {
				return true;
			}
		}
		return false;
	}

	filterOptionList() {
		// if (this.searchMessage) {
		// 	let filteredList = [];
		// 	if (this.displayField instanceof Array) {
		// 		filteredList = this.originalOptionList.filter(item => {
		// 			let filterRawInfo = '';
		// 			if (item.lastName && item.firstName) {
		// 				let lastName = item.lastName
		// 				if (lastName.charCodeAt(0) > 255) {
		// 					item.full_name = item.lastName + item.firstName;
		// 				}
		// 			}
		// 			this.displayField.forEach(field => {
		// 				filterRawInfo += item[field];
		// 			});
		// 			return filterRawInfo.toLowerCase().indexOf(this.searchMessage.toLowerCase()) !== -1;
		// 		});
		// 	} else {
		// 		filteredList = this.originalOptionList.filter(item => item[this.displayField].toLowerCase().indexOf(this.searchMessage.toLowerCase()) !== -1);
		// 	}
		// 	this.optionList = filteredList;
		// } else {
		// 	this.optionList = this.originalOptionList;
		// }
	}

	async cancel() {
		await this.modalController.dismiss();
		history.back();
	}

	async confirm() {
		this.isLoading = true;
		await this.modalController.dismiss(this.selected);
		this.isLoading = false;
		history.back();
	}

	loadMore(event: any) {
		event.target.complete();
	}
}
